import React from "react";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { fetchMyReferrals } from "../../Services/MainService";
import { format, isSameDay, isToday, isYesterday, parseISO } from "date-fns";
import { TitleHeader } from "../../Common/Components/TitleHeader";

const MyReferrals = () => {
  const [data, setData] = React.useState({});
  const [referralLoading, setReferralLoading] = React.useState(false);

  const pending = data?.referral_rewards?.pending || [];
  const used = data?.referral_rewards?.used || [];
  const referredUsers = data?.referred_users || [];

  const sumAmounts = (arr) =>
    (arr || []).reduce((acc, x) => acc + Number(x?.reward_amount || 0), 0);

  const availableAmount = sumAmounts(pending);
  const usedAmount = sumAmounts(used);

  const formatWhen = (iso) => {
    if (!iso) return "";
    const d = typeof iso === "string" ? parseISO(iso) : iso;
    const prefix = isToday(d) ? "Today " : isYesterday(d) ? "Yesterday " : "";
    const datePart = !isToday(d) && !isYesterday(d) ? "dd MMM yyyy, " : "";
    return `${prefix}${format(d, `${datePart}p`)}`;
  };
  React.useEffect(() => {
    fetchReferrals();
  }, []);
  const fetchReferrals = () => {
    setReferralLoading(true);
    fetchMyReferrals().then(
      (res) => {
        setData(res);
        // console.log(res, `referrals`);
        setReferralLoading(false);
      },
      (er) => {
        console.warn(er);
        toast.error("Something went wrong while fetching referrals.");
      }
    );
  };
  return (
    <>
    <TitleHeader
            title="My Referrals"
            subtitle="Below are you Referral Rewards & History"
          />
    <div className="container py-4">
      {referralLoading ? (
        <div className="text-center">
          <Spinner variant="primary" />
        </div>
      ) : (
        <div className="row g-3">
          <div className="col-12 col-lg-3">
            <h5 className="fw-bold mb-3">Available Referral Rewards</h5>

            <div className="d-grid gap-3">
              <div className="border rounded p-3 d-flex align-items-center justify-content-between">
                <div>
                  <p className="mb-1 text-muted" style={{ fontSize: 13 }}>
                    Available
                  </p>
                  <div className="fw-bold" style={{ fontSize: 18 }}>
                    Rs {Number(availableAmount || 0).toLocaleString()}
                  </div>
                </div>
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: 38, height: 38, background: "#FFF3C6" }}
                >
                  <i className="fa-solid fa-gift" style={{ color: "#fce100" }} />
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-3">
            <div className="d-flex align-items-center gap-2 mb-3">
              <h5 className="fw-bold mb-0">Pending Rewards</h5>
              <span
                className="px-2 py-1 rounded"
                style={{ background: "#fce100", fontSize: 12 }}
              >
                {pending.length}
              </span>
            </div>

            <div className="d-grid gap-3">
              {pending.length ? (
                pending.map((x) => (
                  <div
                    key={x.id}
                    className="border rounded p-3 d-flex align-items-center justify-content-between"
                  >
                    <div className="d-flex align-items-center" style={{ gap: 12 }}>
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: 38, height: 38, background: "#FFF3C6" }}
                      >
                        <i className="fa-solid fa-gift" style={{ color: "#fce100" }} />
                      </div>

                      <div>
                        <div className="fw-semibold">
                          {`${x?.consumer?.f_name || ""} ${x?.consumer?.l_name || ""}`.trim() || "—"}
                        </div>
                        <small className="text-muted">{formatWhen(x?.created_at)}</small>
                      </div>
                    </div>

                    <div className="fw-bold" style={{ color: "#fce100" }}>
                      Rs {Number(x?.reward_amount || 0).toLocaleString()}
                    </div>
                  </div>
                ))
              ) : (
                <small className="text-muted">No pending rewards.</small>
              )}
            </div>
          </div>

          <div className="col-12 col-lg-3">
            <div className="d-flex align-items-center gap-2 mb-3">
              <h5 className="fw-bold mb-0">Used Rewards</h5>
              <span
                className="px-2 py-1 rounded"
                style={{ background: "#fce100", fontSize: 12 }}
              >
                {used.length}
              </span>
            </div>

            <div className="d-grid gap-3">
              {used.length ? (
                used.map((x) => (
                  <div
                    key={x.id}
                    className="border rounded p-3 d-flex align-items-center justify-content-between"
                  >
                    <div className="d-flex align-items-center" style={{ gap: 12 }}>
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: 38, height: 38, background: "#fce100" }}
                      >
                        <i className="fa-solid fa-circle-check" style={{ color: "#C9A400" }} />
                      </div>

                      <div>
                        <div className="fw-semibold">
                          {`${x?.consumer?.f_name || ""} ${x?.consumer?.l_name || ""}`.trim() || "—"}
                        </div>
                        <small className="text-muted">{formatWhen(x?.created_at)}</small>
                      </div>
                    </div>

                    <div className="fw-bold" style={{ color: "#fce100" }}>
                      Rs {Number(x?.reward_amount || 0).toLocaleString()}
                    </div>
                  </div>
                ))
              ) : (
                <small className="text-muted">No used rewards.</small>
              )}
            </div>
          </div>

          <div className="col-12 col-lg-3">
            <div className="d-flex align-items-center gap-2 mb-3">
              <h5 className="fw-bold mb-0">Referral History</h5>
              <span
                className="px-2 py-1 rounded"
                style={{ background: "#fce100", fontSize: 12 }}
              >
                {referredUsers.length}
              </span>
            </div>

            <div className="d-grid gap-3">
              {referredUsers.length ? (
                referredUsers.map((u) => (
                  <div
                    key={u.id}
                    className="border rounded p-3 d-flex align-items-center justify-content-between"
                  >
                    <div className="d-flex align-items-center" style={{ gap: 12 }}>
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: 38, height: 38, background: "#fce100" }}
                      >
                        <i className="fa-solid fa-user" style={{ color: "#C9A400" }} />
                      </div>

                      <div>
                        <div className="fw-semibold">
                          {`${u?.f_name || ""} ${u?.l_name || ""}`.trim() || "—"}
                        </div>
                        <small className="text-muted">{formatWhen(u?.created_at)}</small>
                      </div>
                    </div>

                    <div className="text-muted ">{u?.phone || "—"}</div>
                  </div>
                ))
              ) : (
                <small className="text-muted">No referrals yet.</small>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default MyReferrals;